import { ComponentVersions_3_0 } from 'constants/uxVersions'
import { orgSelectors } from 'ducks/orgs'
import { HardwareComponentType } from 'elements/hardwareSelectorV2/types'
import PremiumExpoTooltip from 'expo/PremiumExpoTooltip'
import { useLoadExpoStand } from 'opensolar-pageeditor/src/renderer/useLoadExpoStand'
import {
  Button,
  ComponentVersionsInherit,
  Dialog,
  DialogActions,
  DialogCloseButton,
  DialogTitle,
  styled,
} from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import appStorage from 'storage/appStorage'
import ModalContent from './ModalContent'

interface PropTypes {
  open: boolean
  onClose: () => void
  component: HardwareComponentType
}

const StyledCloseBtn = styled(DialogCloseButton, { name: 'StyledCloseBtn' })({
  marginLeft: 'auto',
})

const ManufacturerDetailsWrapper = styled('div', { name: 'ManufacturerDetailsWrapper' })({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

const ManufacturerLogoImage = styled('img', { name: 'ManufacturerLogoImage' })({
  width: '55px',
})

const ManufacturerBlock = styled('div', { name: 'ManufacturerBlock' })(({ theme }) => ({
  borderLeft: theme.mixins.borderStandard.border,
  display: 'flex',
  alignItems: 'center',
  marginLeft: 10,
  paddingLeft: 10,
  justifyContent: 'center',
}))

const ToolTipContainer = styled('div', { name: 'PremiumRibbonTooltip' })({
  marginLeft: 10,
})

const ShowcaseModal: FC<PropTypes> = ({ open, onClose, component }) => {
  const translate = useTranslate()
  const [isBrokenLogoUrl, setIsBrokenLogoUrl] = useState(false)

  const orgIso2 = useSelector(orgSelectors.getOrgIso2)
  const { standData, isLoading: isStandDataLoading } = useLoadExpoStand({
    slug: component.partner_expo_stand?.slug ?? '',
    locale: component.partner_expo_stand?.slug ? appStorage.getLocale() : undefined,
    iso2: orgIso2,
  })

  if (!open) return null
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Dialog
        disableEnforceFocus
        open={open}
        style={{ zIndex: 2000 }}
        maxWidth={'sm'}
        PaperProps={{
          style: {
            width: '80%',
            minHeight: 400,
          },
        }}
      >
        <DialogTitle>
          <ManufacturerDetailsWrapper>
            {component.name || component.code}
            {(component.manufacturer_name || component.manufacturer_logo) && (
              <ManufacturerBlock>
                {component.manufacturer_logo && !isBrokenLogoUrl ? (
                  <ManufacturerLogoImage
                    src={component.manufacturer_logo}
                    onError={(e) => {
                      setIsBrokenLogoUrl(true)
                    }}
                  />
                ) : (
                  component.manufacturer_name
                )}
              </ManufacturerBlock>
            )}
            {standData?.org.premium_expo && (
              <ToolTipContainer>
                <PremiumExpoTooltip slug={component.partner_expo_stand?.slug ?? ''} partnerName={standData?.org.name} />
              </ToolTipContainer>
            )}
          </ManufacturerDetailsWrapper>
          <StyledCloseBtn onClick={onClose} />
        </DialogTitle>
        <ModalContent
          component={component}
          standData={standData ?? undefined}
          isStandDataLoading={isStandDataLoading ?? false}
        />
        <DialogActions>
          <Button variant="outlined" onClick={onClose}>
            {translate('Back')}
          </Button>
        </DialogActions>
      </Dialog>
    </ComponentVersionsInherit>
  )
}

export default ShowcaseModal
